import angular = require('angular');
import moment = require('moment');
import { MeurhAdmissaoestagiarioModalService } from '../../modal/admissaoestagiario.modal.service';
import { applyNsjTableInlineMobileLabels } from '../../../../../utils/nsj-table';

export class MeurhAdmissoesestagiarioValetransportepersonalizadoFormController implements ng.IController {

    static $inject = ['$scope', '$element', '$attrs', 'NewToaster', '$rootScope', '$sce', 'MeurhAdmissaoestagiarioModalService'];

    public entity: any;
    public action: string;
    public fields: any = applyNsjTableInlineMobileLabels([
        {
            value: 'datainicio',
            label: 'Início',
            type: 'date',
            style: 'title',
            copy: '',
        },
        {
            value: 'datafim',
            label: 'Fim',
            type: 'date',
            style: 'title',
            copy: '',
        },
        {
            value: 'tipo',
            label: 'Tipo',
            type: 'string',
            style: 'default',
            copy: '',
            customCollumnHtml: () => {
                let someHtmlVar = `
                <span>{{(tableRowEntity.tipo==1) ? 'Dias Úteis' : 'Valor Recebido Tarifas'}}</span>
              `;
                return someHtmlVar;
            },
        },
        {
            value: 'conteudo',
            label: 'Conteúdo',
            type: 'moeda',
            style: 'default',
            copy: '',
        },
        {
            value: 'motivo',
            label: 'Motivo',
            type: 'string',
            style: 'default',
            copy: '',
        },
    ]);

    constructor(
        public $scope: angular.IScope,
        public $element: any,
        public $attrs: any,
        public NewToaster: any,
        public $rootScope: angular.IRootScopeService & { configuracoes: any, session: any },
        public $sce: angular.ISCEService,
        public MeurhAdmissaoestagiarioModalService: MeurhAdmissaoestagiarioModalService
    ) {

    }

    $onInit(): void {
       if (this.entity.vtspersonalizados === undefined || this.entity.vtspersonalizados === null) {
           this.entity.vtspersonalizados = [];
       }
    }

    abrirModal(entity: any = {}, action: string = ''): void {
        let parameters = {
            'componente' : 'VT Personalizado',
            'action' : action ? action : this.action ,
        };

        let modal = this.MeurhAdmissaoestagiarioModalService.open(entity, parameters);

        modal.result
            .then((response: any): void => {
                this.entity.vtspersonalizados.push(response);
            })
            .catch((error: any): void => {
                console.log(error);
            });
    }
}
